import { getLabelCaptions } from './get-captions';

const getPlanLabel = (type, current, popular, valuable, limited) => {
  const PLAN_LABEL = getLabelCaptions();
  if (current === type) return PLAN_LABEL.current;
  if (limited) return PLAN_LABEL.limited;
  if (popular) return PLAN_LABEL.popular;
  if (valuable) return PLAN_LABEL.valuable;
  return '';
};

export default getPlanLabel;
